import type { Baby } from '../../data/types';
import { baby as defaultBaby } from '../../data/baby';

interface AvatarProps {
  size?: number;
  baby?: Baby;
}

/**
 * Initials avatar. Colour is derived from the active accent CSS var, so it
 * follows the gender preset without prop drilling.
 */
export function Avatar({ size = 44, baby }: AvatarProps) {
  const b = baby ?? defaultBaby;
  return (
    <div
      className="flex items-center justify-center rounded-full font-serif shrink-0 text-accent-ink"
      style={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        letterSpacing: '0.5px',
        background: `color-mix(in oklch, var(--color-accent) 18%, var(--color-bg))`,
      }}
    >
      {b.initials}
    </div>
  );
}

interface AvatarButtonProps extends AvatarProps {
  onOpenProfile: () => void;
}

export function AvatarButton({ size = 36, baby, onOpenProfile }: AvatarButtonProps) {
  return (
    <button
      onClick={onOpenProfile}
      aria-label="Open profile"
      className="flex items-center justify-center min-h-11 min-w-11 rounded-full cursor-pointer"
    >
      <Avatar size={size} baby={baby} />
    </button>
  );
}
